













import { Component, Prop, Mixins } from 'vue-property-decorator';
import { MoreIcon } from '@/components/icons/MoreIcon';
import { LessIcon } from '@/components/icons/LessIcon';
import store from '@/store';
import BaseMixin from '@/mixins/BaseMixin';
import { RelatedPartsModuleTypes } from '@/store/modules/related-parts';

@Component({
    store,
    components: {
        MoreIcon,
        LessIcon,
    },
})
export default class RelatedPartsAction extends Mixins(BaseMixin) {
    @Prop(String)
    private fullPartId!: string;

    public toggleRelatedParts(): void {
        if (this.showRelatedParts) {
            this.$store.dispatch(
                RelatedPartsModuleTypes.actions.unloadRelatedParts
            );
        } else {
            this.$store.dispatch(
                RelatedPartsModuleTypes.actions.loadRelatedParts,
                {
                    id: this.fullPartId,
                }
            );
        }
    }

    public get showRelatedParts(): boolean {
        return (
            this.$store.getters[RelatedPartsModuleTypes.getters.partId] &&
            this.fullPartId ===
                this.$store.getters[RelatedPartsModuleTypes.getters.partId]
        );
    }
}
